import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import {
  Alert, Button, Text, Textarea,
} from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import prepareTranslate from '@/helpers/dictionary';
import Modal from '@/components/DetailsModal';
import styles from './index.module.css';

/**
 * Soft deletes the email record - the row is removed from the agent's email log
 * in Equity, the message in the agent's mailbox is untouched.
 */
const DeleteAgentEmail = (props) => {
  const {
    email,
    opened,
    close,
    onDelete,
    loading,
  } = props;

  const t = prepareTranslate();
  const [reason, setReason] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!opened) return;

    setReason('');
    setError(null);
  }, [opened]);

  const handleDelete = () => {
    if (!reason.trim()) {
      setError(t('validations.required'));
      return;
    }

    onDelete(reason.trim());
  };

  const actions = [
    <Button key='delete' color='red' onClick={handleDelete} loading={loading} w={120}>
      {t('global.delete')}
    </Button>,
    <Button key='cancel' variant='outline' onClick={close} w={120}>
      {t('global.cancel')}
    </Button>,
  ];

  return (
    <Modal
      opened={opened}
      close={close}
      actions={actions}
      size='50%'
      label={t('components.viewAgentEmails.delete.label')}
    >
      <Alert
        icon={<IconInfoCircle />}
        color='blue'
        variant='light'
        className={styles.notice}
      >
        {t('components.viewAgentEmails.delete.notice')}
      </Alert>

      <Text className={styles.verify}>
        {t('components.viewAgentEmails.delete.verify')}
      </Text>
      <Text fw={500} className={styles.emailName}>{email?.name}</Text>

      <Textarea
        label={t('components.viewAgentEmails.delete.reason')}
        value={reason}
        error={error}
        withAsterisk
        autosize
        minRows={3}
        onChange={(event) => {
          setReason(event.currentTarget.value);
          setError(null);
        }}
      />
    </Modal>
  );
};

DeleteAgentEmail.propTypes = {
  email: PropTypes.object,
  opened: PropTypes.bool,
  close: PropTypes.func,
  onDelete: PropTypes.func,
  loading: PropTypes.bool,
};

export default DeleteAgentEmail;
